<script setup lang="ts">
import { computed } from 'vue'
import { EyeIcon } from '@heroicons/vue/24/outline'

const props = defineProps(['params'])
const row = computed(() => props.params?.data)

function onView() {
  if (props.params?.onClickView) {
    props.params.onClickView(row.value)
  }
}
</script>

<template>
  <div class="flex items-center justify-center w-full">
    <button type="button" class="btn btn-ghost btn-sm gap-2" @click="onView">
      <EyeIcon class="h-4 w-4" />
      Détails
    </button>
  </div>
</template>
